<template>
    <div class="news-card">
        <div v-if="isAdminOrCollaborator" class="actions" :class="{'actions-primary': primaryCard}">
            <ui-menu-card
                :icon-size="20"
                design-btn="primary-alt"
            >
                <button type="button" @click="editNews">Editar publicação</button>
                <button type="button" @click="deleteNews(id)">Excluir</button>
            </ui-menu-card>
        </div>
        <div class="card-link" @click="viewNews">
            <div class="card-cover" :class="{'card-cover-primary': primaryCard}" :style="getHighlightedStyle">
                <span v-if="categoryName" class="category-name">{{ categoryName }}</span>
            </div>
            <div class="card-details">
                <div class="info-news">
                    <h2>{{ title }}</h2>
                    <p v-add-html="formatText(desc, 200, true)" />
                    <i class="fal fa-long-arrow-right" />
                </div>
                <div class="info-publication">
                    Publicado em {{ formatDate(createdAt) }}
                </div>
            </div>			
        </div>
    </div>
</template>

<script>
import { uiMenuCard } from '@/components/ui'

const moment = require('moment')
require('moment/locale/pt-br')

import { mapGetters } from 'vuex'
import * as userGroups from '../util/userGroups.js'

import helpers from '@/mixins/helpers'

export default {
	name: 'ui-news-card',
	components: {
		uiMenuCard,
	},

	mixins: [helpers],

	props: {
		/**
		 * Uma URI da imagem a ser usada
		 */
		cover: {
			type: String,
			required: true,
			default: null,
		},
		/**
		 * Um título para o card
		 */
		title: {
			type: String,
			required: true,
			default: null,
		},
		/**
		 * Uma descrição para o card
		 */
		desc: {
			type: String,
			required: true,
			default: null,
		},
		/**
		 * A categoria da novidade a ser mostrada na parta superior do card (só irá aparecer se o valor passado for diferente de null)
		 */
		categoryName: {
			type: String,
			required: true,
			default: null,
		},
		/**
		 * Uma descrição de data de criação
		 */
		createdAt: {
			type: String,
			required: true,
			default: null,
		},
		/**
		 * Estilo do card. Ela é uma novidade destacada ou não?
		 */
		isHighlighted: {
			type: Boolean,
			required: false,
			default: false,
		},
		/**
		 * Id da novidade
		 */
		id: {
			type: Number,
			required: true,
			default: null,
		},

		primaryCard: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		...mapGetters('auth', { user: 'getUser' }),
		...userGroups,

		getValidCover() {
			if (this.cover) return this.cover

			return require('@/assets/imgs/no-image.jpg')
		},

		getUserPhoto() {
			return { backgroundImage: `url('https://pbs.twimg.com/media/FjU2lkcWYAgNG6d.jpg')` }
		},

		getHighlightedStyle() {
			return {
				backgroundImage: `url('${this.getValidCover}')`,
			}
		},
	},

	methods: {
		viewNews() {
			this.$router.push({
				name: 'news.view',
				params: { id: this.id },
			})
		},

		editNews() {
			this.$router.push({
				name: 'news.edit',
				params: { id: this.id },
			})
		},

		formatDate(toFormat) {
			return moment(toFormat).format('L [às] LT')
		},

		/* I could use text-overflow, but the description would
			be all in the DOM and we don't want unnecessary
			text that the user won't even see */
		formatText(toFormat, characters, transformNormalText) {
			// Show only the first X characters and delete the rest

			if (!transformNormalText)
				return toFormat.slice(0, characters) + (toFormat.length > characters ? '...' : '')

			let normalText = this.stripTags(toFormat)
			return normalText.slice(0, characters) + (normalText.length > characters ? '...' : '')
		},

		deleteNews(id) {
			this.$root.$emit('modal-msg-open-delete-news-list', {
				method: 'delete',
				url: '',
				id: id,
				msg: 'Não foi possível excluir a novidade, tente novamente!',
				eventSuccess: 'set-data-news-deleted-list',
			})
		},
	},
}
</script>

<style lang="stylus" scoped>
@import 'styles.styl';
</style>
